import type { Quote } from "./testimonials";

export const MOCK_QUOTES: Quote[] = [
  {
    quote:
      "‘An exciting murder mystery dinner game with a pinch of humour. We tried Culinario Mortale and were positively surprised. The game materials are well structured (and also look damn good).’",
    source: "What others say",
  },
];
